<div>
  <div style="display: flex; align-items: start; gap: 10px">
    <div>
      <h2>Users</h2>
    </div>
    @if (this.enableEditing) {
      <div [hidden]="addingUser || editingUser">
        <app-button-input
          [icon]="'PlusAdd'"
          (click)="btnAddUser_click()"
          [title]="'Add a new contact'"
        ></app-button-input>
      </div>
    }
  </div>

  <div [hidden]="selectedUser != undefined || addingUser || editingUser">
    <app-filterable-table
      #userTable
      [tableView]="userTableView"
      (selectedRecord)="handleUserSelected($event)"
    ></app-filterable-table>
  </div>

  <div [hidden]="!addingUser || !enableEditing">
    <app-user-form
      #newUserForm
      [merchantId]="merchant?.id"
      [enableEditing]="enableEditing"
      [enableSaving]="true"
      [enableSelectExistingUser]="true"
      [initialMode]="formMode.Edit"
      (created)="handleUserSaved($event)"
      (cancelled)="handleUserCancelled()"
      (saved)="handleUserSaved($event)"
    ></app-user-form>
  </div>

  <div [hidden]="!selectedUser || !enableEditing">
    <app-edit-user
      #editUserForm
      [merchantId]="merchant?.id"
      [user]="selectedUser"
      [enableRoleSelection]="enableRoleSelection"
      [enableEditing]="enableEditing"
      [enableSaving]="true"
      [initialMode]="formMode.Edit"
      (cancelled)="handleUserCancelled()"
      (saved)="handleUserSaved($event)"
    ></app-edit-user>
  </div>
</div>
